<template>
  <div>
    <div v-if="selectedFolder != null" class="pa-2" @click="back()" style="cursor: pointer;">
      <v-icon>mdi-chevron-left</v-icon>voltar
    </div>
    <div v-if="selectedFolder == null">
      <div class="d-flex ma-4 ml-6" style="width: 100%;">
        <v-card v-for="folder in folders" :key="folder.id" @click="selectFolder(folder)" elevation="0" class="px-4 mr-4">
          <div class="d-flex flex-column align-center">
            <v-img src="../../assets/folder.png" height="85px" width="85px" contain>
            </v-img>
            <p style="font-weight: 500;">
              {{ folder.name }}
            </p>
          </div>
        </v-card>
      </div>
    </div>
    <div v-else>
      <div class="d-flex ma-4 ml-6" style="width: 100%;">
        <v-card v-for="folder in selectedFolder.subfolders" :key="folder.id" @click="selectFolder(folder)" elevation="0"
          class="px-4 mr-4">
          <div class="d-flex flex-column align-center">
            <v-img src="../../assets/folder.png" height="85px" width="85px" contain>
            </v-img>
            <p style="font-weight: 500;">
              {{ folder.name }}
            </p>
          </div>
        </v-card>
        <v-card v-for="file in selectedFolder.files" :key="file.id"
          class="d-flex flex-column elevation-0 pa-2 grey lighten-3"
          style="margin-right: 30px; align-items: center; justify-content: center; max-width: 220px; min-width: 150px;"
          @click="selectFile(file)">
          <v-icon v-if="file.filetype == 'pdf'" size="60" color="#D32E2E">mdi-file-pdf-box</v-icon>
          <v-icon v-else-if="file.filetype == 'video'" size="60" color="#FF9800">mdi-play-box-outline</v-icon>
          <v-icon v-else-if="file.filetype == 'image'" size="60" color="#388E3D">mdi-image</v-icon>
          <v-icon v-else-if="file.filetype == 'other'" size="60" color="#2296F3">mdi-file</v-icon>
          <p style="font-weight: 500; margin-top: 10px; text-align: center; ">
            {{ file.name }}
          </p>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="showDialog" transition="dialog-bottom-transition" max-width="1200px" >
      <v-card dark>
        <v-toolbar class="primary">
          <v-toolbar-title>{{ selectedFile.name }}</v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon dark :href="selectedFile.url" target="_blank" v-on="on">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Abrir em Nova aba</span>
          </v-tooltip>
          <v-btn icon dark @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <div>
          <iframe :src="embedUrl(selectedFile)" frameborder="0" allowfullscreen 
            style="width: 100%; height: 100%; min-height: 600px;"></iframe>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Trainings",
  data: () => ({
    selectedFile: {
      name: "",
      url: "",
      filetype: "",
    },
    showDialog: false,
    folders: [],
    selectedFolder: null,
    folderHistory: [],
  }),
  methods: {
    async getFolders() {
      this.loading = true;
      this.error = false;
      try {
        const response = await this.$axios.get('/manual');
        this.folders = response.data;
        this.selectedFolder = null;
      } catch (e) {
        console.log(e);
        this.$showMessage('error', "Erro inesperado ao buscar os arquivos")
      } finally {
        this.loading = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.error = true;
          }, 1000);
        });
      }
    },

    embedUrl(file) {
      let url = file.url;
      if (file.filetype == "video" && url.includes("youtube")) {
        const youtubePrefix = 'https://www.youtube.com/watch?v=';
        if (url.startsWith(youtubePrefix)) {
          url = url.replace(youtubePrefix, "");
          if (url.includes("&")) url = url.split("&")[0];
          return "https://www.youtube.com/embed/" + url;
        }
      }
      return url; 
    },

    selectFile(file) {
      this.selectedFile = file;
      this.showDialog = true;
    },

    closeDialog() {
      this.selectedFile = ""
      this.selectedFile = ""
      this.showDialog = false
    },



    selectFolder(folder) {
      this.folderHistory.push(folder);
      this.selectedFolder = this.folderHistory[this.folderHistory.length - 1];
    },

    back() {
      if (this.folderHistory.length <= 1) {
        this.selectedFolder = null;
      } else {
        this.folderHistory.pop();
        this.selectedFolder = this.folderHistory[this.folderHistory.length - 1];
      }
    }
  },
  mounted() {
    this.getFolders();
  },
}
</script>
